import ilComponent from './Relation'

export default Vue => {
    Vue.component(ilComponent.name, ilComponent);
}
